import softDelete from './delete';
import edit from './edit';
import packageCreate from './package';
import show from './show';
import print from './printDeclaration';

export default {
  edit,
  packageCreate,
  show,
  print,
  softDelete,
};
